import React, { Dispatch, SetStateAction, useMemo } from 'react'

import { Button, Grid, Typography } from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'
import { FormSpacer } from 'components/libs/layout/pages/pageLayout'
import styles from 'components/pages/inboundSettings/inboundSettingsStyles'
import DomainTable from 'components/libs/domainTable/DomainTable'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'
import { useAntifraudExemptLogic } from './useAntifraudExemptLogic'

const BASE_I18N_KEY = 'ess.inbound_settings.anti_phishing'
const BASE_INBOUND_I18N_KEY = 'ess.inbound_settings'

export interface AntifraudExemptProps {
  delegateDirtyFormState: Dispatch<SetStateAction<boolean>>
}

const AntifraudExempt: React.FC<AntifraudExemptProps> = (props: AntifraudExemptProps) => {
  const isReadonly = useIsReadonly()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatInboundMessage = useFormatMessage(BASE_INBOUND_I18N_KEY)
  const inboundClasses = styles()
  const [state, eventHandlers] = useAntifraudExemptLogic()

  return useMemo(
    () => (
      <Grid container>
        <Typography variant="h4">{formatMessage('antifraud_exemptions')}</Typography>
        <FormSpacer />
        <Button
          className={inboundClasses.bulkEdit}
          onClick={eventHandlers.onBulkEdit}
          variant="contained"
          size="small"
          data-testid="bulk-button-antifraud-exempt"
          disabled={isReadonly}
        >
          {formatInboundMessage('bulk_edit')}
        </Button>
        <DomainTable
          data={state.tableData}
          onAddItem={eventHandlers.onAddItem}
          onRemoveItem={eventHandlers.onRemoveItem}
          shouldHandleEmail
          isLoading={state.isLoading}
          data-testid="antifraud-exempt-table"
          delegateDirtyFormState={props.delegateDirtyFormState}
        />
      </Grid>
    ),
    [
      formatMessage,
      formatInboundMessage,
      inboundClasses.bulkEdit,
      eventHandlers,
      state.tableData,
      state.isLoading,
      isReadonly,
      props.delegateDirtyFormState
    ]
  )
}

export default AntifraudExempt
